import styled from 'styled-components';

export const StyledMachineRobotCleaningStatus = styled.div`
  &.machine-robot-cleaning-status__data {
    display: inline-flex;
    align-items: center;
    gap: ${(props): string => props.theme.kcc.spacing.XS};
    color: ${(props): string => props.theme.kcc.colors.PRIMARY};
    font-family: ${(props): string => props.theme.fonts.heading3};
    font-size: ${(props): number => props.theme.kcc.typography.FONT_SIZE.BASE}px;
    font-weight: ${(props): number => props.theme.kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
    line-height: ${(props): number => props.theme.kcc.typography.LINE_HEIGHT.LG};

    .machine-robot-cleaning-status__dot {
      flex: 0 0 auto;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      align-self: flex-start;
      margin-top: 3px;
    }

    .machine-robot-cleaning-status__label {
    }

    &.cleaning-status .machine-robot-cleaning-status__dot,
    &.paused-status .machine-robot-cleaning-status__dot {
      background-color: ${(props): string => props.theme.colors.semanticInfo};
    }

    &.standby-status .machine-robot-cleaning-status__dot {
      background-color: ${(props): string => props.theme.colors.primary};
    }

    &.docking-status .machine-robot-cleaning-status__dot {
      background-color: #64d9ff;
    }

    &.manualcharging-status .machine-robot-cleaning-status__dot {
      background-color: #00e200;
    }

    &.offline-status .machine-robot-cleaning-status__dot {
      background-color: ${(props): string => props.theme.colors.grey300};
    }

    &.na-status .machine-robot-cleaning-status__dot {
      background-color: ${(props): string => props.theme.colors.brightGrey};
    }

    &.exploration-status .machine-robot-cleaning-status__dot {
      background-color: ${(props): string => props.theme.colors.secondary};
    }
  }
`;
